import React,{ Component, PropTypes } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { ItemTypes } from './Constants';
import { DragSource, DropTarget } from 'react-dnd';
import { addBlock } from '../actions/index';
import equal from 'deep-equal';
import _ from 'lodash';

const blockSource = {
  beginDrag(props){
    return {
      type: 'block',
      element: props.element
    }
  }
}

class SectionItem extends Component {
  constructor(props){
    super(props)

    this.state = {
      showImage: false
    }
  }

  componentWillReceiveProps(nextProps){
    if(!equal(nextProps.element, this.props.element)){
      this.setState({
        showImage: false
      })
    }
  }

  render(){
    const { element, url, pro, authorised, isDragging, connectDropTarget, connectDragPreview, connectDragSource } = this.props;

    let imgStyle = {
      opacity: 0,
      height: '140px'
    }

    let liStyle ={
      backgroundColor: '#fff'
    }

    if(this.state.showImage){
      imgStyle = {
        opacity: 1,
        height: 'auto'
      }
    }

    if(authorised !== ''){
      imgStyle.cursor = 'default'
    }

    let html = <li style={liStyle}>
      {
        !this.state.showImage &&
        <i className="fa fa fa-circle-o-notch fa-spin"></i>
      }
      <img src={`${url}/sections/${element.type}/thumbs/${element.banner}`} style={imgStyle} onLoad={e => this.setState({ showImage: true })}/>
      {
        authorised == ''
        ?
        <div className="sppb-overlayer"><i className="fa fa-arrows" /> Drag</div>
        :
        <div className="sppb-overlayer" style={{cursor: 'default'}}>{authorised}</div>
      }
      {
        !pro &&
        <div className="sppb-pro-badge sppb-pro-section">Pro</div>
      }
    </li>

    if(authorised == '' || !_.isEmpty(element.section)){
      return connectDragPreview(connectDragSource(html))
    } else {
      return html
    }

  }
}

var DragSourceDecorator = DragSource(ItemTypes.BLOCK, blockSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);

const mapStateToProps = ( state ) => {
  return {state};
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addBlock: ( rowIndex, dragIndex, hoverIndex ) => {
      dispatch( addBlock( rowIndex, dragIndex, hoverIndex ) )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DragSourceDecorator(SectionItem));



// WEBPACK FOOTER //
// ./src/components/SectionItem.js